import type { PersistedSliceDescriptor } from "../types";

/**
 * Authoring helper that preserves generic `TValue` on a persisted slice descriptor.
 *
 * @typeParam TValue In-memory slice type inferred from the Zod schema.
 * @param descriptor Complete slice configuration.
 * @returns The same descriptor reference, typed for export and registry inclusion.
 */
export const definePersistedSlice = <TValue>(
    descriptor: PersistedSliceDescriptor<TValue>,
): PersistedSliceDescriptor<TValue> => {
    return descriptor;
};
